import { ProposalService } from "src/services";
import { LoanApplication } from "src/types/loan-application/index";
import { Residuals } from "src/types/quote/index";
//@ts-ignore
import { constructResidualsRequest } from "@cf247/pricing/src/monthly-payment-calculator"
import { useSettingsStore } from "src/stores/settings-store";
import Residual from "src/types/quote/residual";

export default function useFutures(app: LoanApplication, quickQuote = false) {
  return new Promise<Residuals | null>(async (resolve, reject) => {

    // If annual mileage hasnt changed since last check, do not try to re get residuals
    if (app.vehicle.futuresMileage && app.vehicle.futuresMileage === app.vehicle.annualMileage) {
      resolve(app.vehicle.futures ?? null)
      return;
    }

    const request = await constructResidualsRequest(
      app.vehicle,
      app.deposit ?? 0,
      app.proposals,
      useSettingsStore().termsToShow,
      app.vehicle.annualMileage
    );


    if (!request) {
      resolve(null);
      return;
    }

    if(quickQuote){
      request.financeCompanyResidualSetting = [
        {
          financeCompanyId: 50,
          residualValueRequestType: 3
        },
        {
          financeCompanyId: 75,
          residualValueRequestType: 3
        }
      ]
    }

    ProposalService.getResiduals(request).then(response => {
      
      console.log("futures response", response);
      if (!response) {
        app.vehicle.futuresRequestFailed = true;
        resolve(null);
        return;
      }

      const mappedResiduals: Residuals = {};

      response.forEach(residual => {
        const rs: Residual = {};
        residual.residualValues.forEach(term => {
          rs[term.term] = term.value;
        });
        mappedResiduals[residual.financeCompanyId] = rs;
      });
      
      app.vehicle.futures = mappedResiduals;

      resolve(mappedResiduals);
    }).catch(error => {
      console.log("futures error", error);
      app.vehicle.futures = null;
      resolve(null)
      return;
    })
  })
}
